import { render, staticRenderFns } from "./ReviewCommentsThread.vue?vue&type=template&id=728cecc4&scoped=true"
import script from "./ReviewCommentsThread.vue?vue&type=script&lang=js"
export * from "./ReviewCommentsThread.vue?vue&type=script&lang=js"
import style0 from "./ReviewCommentsThread.vue?vue&type=style&index=0&id=728cecc4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "728cecc4",
  null
  
)

export default component.exports